import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        backdrop: (_a = {
                display: 'block',
                position: 'fixed',
                top: '0',
                bottom: '0',
                left: '0',
                right: '0',
                background: 'hsla(var(--gris-l3-h), var(--gris-l3-s), var(--gris-l3-l), 0.5)',
                transition: 'var(--transition) opacity',
                zIndex: 3
            },
            _a[theme.breakpoints.down('sm')] = {
                zIndex: 2,
            },
            _a),
        modal: (_b = {
                position: 'fixed',
                top: '50%',
                left: '50%',
                background: 'var(--blanco)',
                padding: '2.75rem',
                borderRadius: '0.625rem',
                boxShadow: 'var(--box-shadow)',
                transform: 'translate(-50%, -50%)',
                zIndex: 4
            },
            _b[theme.breakpoints.down('sm')] = {
                width: '90%',
                padding: '2.125rem',
            },
            _b),
        cerrarButton: {
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            alignItems: 'center',
            width: '1.5rem',
            height: '1.5rem',
            display: 'flex',
            padding: '0',
            borderRadius: '50%',
            border: '1px solid var(--gris-l3)',
            opacity: '0.2',
            justifyContent: 'center',
        },
        cerrarIcon: {
            '--icon-primary-dark': 'var(--gris-l3)',
            width: '0.625rem',
            height: '0.625rem',
        },
    });
});
export default useStyles;
